import styled from 'styled-components';

export const StyledButtonWrapper = styled.div`
  justify-content: center;
  display: flex;
  width: 100%;
  > button:first-of-type {
    margin-right: ${({ theme }) => theme.spacing(6)};
  }
`;
